export default __webpack_public_path__ + "static/4-bd7dc24b616e0020d057f915ff60c199.png";